import script from "./ContentBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentBlock.vue?vue&type=script&setup=true&lang=js"

import "./ContentBlock.vue?vue&type=style&index=0&id=97493be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97493be6"]])

export default __exports__